import { useEffect } from "react";
import { mixpanel, redirect, redactUrlForTelemetry } from "../utils";
import { MIXPANEL_EVENTS } from "../constants";

let linkTrackingEnabled = false;

const handleClickEvent = e => {
  const { target } = e;
  const a = target instanceof HTMLAnchorElement
    ? target
    : target instanceof Element
      ? target.closest('a')
      : null;

  const linkName = a?.getAttribute('data-mp-name');

  if (!linkName) return;

  const href = a.href;
  const location = redactUrlForTelemetry(document.location.href);

  if (href) e.preventDefault();

  mixpanel.track(MIXPANEL_EVENTS.clickLink, {
    linkName,
    location,
    href: redactUrlForTelemetry(href),
  });

  if (href) redirect(href, true); // allow external links
};

const useMixpanelPageTracking = (enabled = true) => {
  useEffect(() => {
    if (!enabled) return;
    if (linkTrackingEnabled) return; // prevent double bind

    document?.addEventListener('click', handleClickEvent);
    
    linkTrackingEnabled = true;

    return () => {
      if (!linkTrackingEnabled) return; // prevent double unbind (mainly perf reasons)

      document?.removeEventListener('click', handleClickEvent);

      linkTrackingEnabled = false;
    };
  }, [enabled]);
};

export default useMixpanelPageTracking;
